export function findItemByName(items, name) {

  for (const item of items) {

    if (item.children) {
      const foundItem = findItemByName(item.children, name);
      if (foundItem) {
        return foundItem;
      }
    }

    if (item.name === name) {
      return item;
    }
  }
  return null;
}